import InboxRuleRequestStatus from '../../store/schema/InboxRuleRequestStatus';
import { InboxRulesListOptionState } from '../../store/schema/InboxRulesListOptionState';
import store from '../../store/store';
import { action, select } from 'satcheljs/lib/legacy';

export interface SetGetInboxRuleRequestStatusState {
    optionState: InboxRulesListOptionState;
}
/**
 * Set the getInboxRuleRequestStatus in the inbox rules options store
 * @param requestStatus the get inbox rules request status to set
 * @param state the state which contains the store
 */
export default action('setGetInboxRuleRequestStatus')(
    select({
        optionState: () => store.inboxRulesListState,
    })(function setGetInboxRuleRequestStatus(
        requestStatus: InboxRuleRequestStatus,
        state?: SetGetInboxRuleRequestStatusState
    ) {
        let { optionState } = state;
        optionState.getInboxRuleRequestStatus = requestStatus;
    })
);
